var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCookie, sleep } from './common-utils';
const defHost = '//api.live.bilibili.com';
/**
 * api url 对应需要随机延迟的时间范围
 */
const disperseMap = new Map();
const _watchers = new Set();
/**
 * 封装fetch，方便接收后端api数据
 */
export function ajax(url, opts) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const startTs = performance.now();
        let apiUrl = url;
        if (!/^(https?:)?\/\//.test(url)) {
            apiUrl = `${defHost}/${url.replace(/^\//, '')}`;
        }
        const urlObj = new URL(apiUrl, location.href);
        const disperseCfg = disperseMap.get(urlObj.host + urlObj.pathname);
        if (disperseCfg != null) {
            if (disperseCfg.expiresTime > performance.now()) {
                const delayTime = Math.random() * disperseCfg.scope;
                yield sleep(delayTime);
            }
        }
        // 安全团队要求，需携带 csrsToken
        const csrfToken = getCookie('bili_jct');
        if (csrfToken !== '' &&
            (opts === null || opts === void 0 ? void 0 : opts.method) === 'POST' &&
            (opts === null || opts === void 0 ? void 0 : opts.data) != null) {
            const fd = new FormData();
            const params = Object.assign(Object.assign({}, ((_a = opts.data) !== null && _a !== void 0 ? _a : {})), { csrf: csrfToken, csrf_token: csrfToken });
            Object.keys(params)
                .forEach((key) => {
                fd.append(key, params[key]);
            });
            opts.body = fd;
        }
        let res;
        try {
            res = yield fetch(apiUrl, Object.assign({ credentials: 'include' }, (opts !== null && opts !== void 0 ? opts : {})));
        }
        catch (err) {
            const errMsg = String(err);
            _watchers.forEach(watcher => watcher('requestErr', {
                errMsg: errMsg,
                apiUrl: urlObj.pathname
            }));
            throw new Error(errMsg);
        }
        if (!res.ok) {
            const errMsg = `url: ${url}, status: ${res.status}`;
            _watchers.forEach(watcher => watcher('responseErr', {
                errMsg: `status: ${res.status}`,
                apiUrl: urlObj.pathname
            }));
            throw new Error(errMsg);
        }
        const rs = yield res.json();
        _watchers.forEach(watcher => watcher('perf', {
            duration: performance.now() - startTs,
            apiUrl: urlObj.pathname
        }));
        // 调用方希望自己处理返回值，一般用于处理特殊 code
        if (typeof (opts === null || opts === void 0 ? void 0 : opts.handleRes) === 'function') {
            opts.handleRes(rs);
            return rs.data;
        }
        const { code, data, message } = rs;
        if (code !== 0) {
            _watchers.forEach(watcher => watcher('apiBizErr', {
                errMsg: message,
                apiUrl: urlObj.pathname
            }));
            throw new Error(message);
        }
        return data;
    });
}
ajax.watch = (fn) => {
    _watchers.add(fn);
    return () => {
        _watchers.delete(fn);
    };
};
/**
 * 将某个接口分散，延时（随机）发送请求，避免对服务造成过大压力
 * @param url 接口 url
 * @param scope 随机分布的时间范围，单位 ms expiresTime需要加上performance.now()
 */
ajax.disperse = (url, cfg) => {
    const apiUrl = /^(https?:)?\/\//.test(url)
        ? url
        : `${defHost}/${url.replace(/^\//, '')}`;
    disperseMap.set(apiUrl.replace(/^(https?:)?\/\//, ''), cfg);
};
//# sourceMappingURL=ajax.js.map